import React from 'react';
import { useRevealChildren } from '../../hooks/useRevealChildren';
import { sdgGoals } from '../../data/sdgGoals';
import SDGItem from './SDGItem';
import './SDGs.css';

function SDGs() {
  const ref = useRevealChildren();

  return (
    <section className="sdg-section" ref={ref}>
      <div className="container">
        <div className="section-header reveal">
          <div className="section-eyebrow">Global Commitment</div>
          <h2 className="section-title">
            STUPA And <em>Sustainable<br />Development Goals</em>
          </h2>
          <p className="section-subtitle">
            Aligned with the United Nations' vision for a sustainable future,
            our work directly contributes to these critical global goals.
          </p>
        </div>
        <div className="sdg-grid">
          {sdgGoals.map((goal) => (
            <SDGItem key={goal.number} {...goal} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default SDGs;
